import { useTranslation } from "react-i18next";

import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import { HubUpdateTarget, useHubUpdate } from "./useHubUpdate";

type HubUpdateChipType = {
  emrHub: HubUpdateTarget;
};

const HubUpdateChip = ({ emrHub }: HubUpdateChipType) => {
  const { t } = useTranslation();
  const { canDownload, isOutdated, latestVersion } = useHubUpdate(emrHub);

  if (!isOutdated) return null;

  return (
    <Tooltip
      title={
        canDownload
          ? t("Download the installer and run it on the hub PC.")
          : t("Someone with access to the hub's home clinic can download it.")
      }
    >
      <Typography
        component="span"
        data-testid="hub-update-chip"
        fontSize="12px"
        fontWeight={600}
        sx={{
          flexShrink: 0,
          padding: "0px 8px",
          whiteSpace: "nowrap",
          color: "#E2772E",
          border: "1px solid #E2772E",
          borderRadius: "4px",
        }}
      >
        {t("Update {{version}} available", { version: latestVersion })}
      </Typography>
    </Tooltip>
  );
};

export default HubUpdateChip;
